// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1dVUt","productName":"Table_productName__2SOUx"};